export enum Scheme {
  Single = 'single',
  Pair = 'pair',
  Sequence = 'sequence',
}
